module.exports = __webpack_public_path__ + "static/media/gifthy-load.910ba089.gif";